import clsx from 'clsx';
import { Temporal } from 'temporal-polyfill';
import { AttendancePolicyV2HistoryEventKind } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge';
import {
  AttendancePolicyV2HistoryEventBadgeColorMap,
  AttendancePolicyV2HistoryEventDotColorMap,
} from '@/lib/attendance-policy-v2-display';
import { VerticalTimeline } from '@/components/vertical-timeline';

export const AttendancePolicyV2HistoryModalItem = ({
  kind,
  eventPlainDate,
  title,
  explanation,
  outcomeLabel,
}: {
  kind: AttendancePolicyV2HistoryEventKind;
  eventPlainDate: Temporal.PlainDate;
  title: string;
  explanation: string | null;
  outcomeLabel: string;
}) => {
  return (
    <li className="flex items-start gap-4">
      <VerticalTimeline color={AttendancePolicyV2HistoryEventDotColorMap[kind]} />
      <div className="flex flex-1 min-w-0 items-center gap-4 border-b border-slate-200 py-2">
        <div className="text-xs min-w-20">
          {eventPlainDate.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </div>
        <div className="flex flex-col flex-1 justify-start">
          <span className="text-sm font-medium">{title}</span>
          {explanation ? <div className="text-xs text-muted-foreground whitespace-pre-wrap">{explanation}</div> : null}
        </div>
        <div className="flex justify-start">
          <Badge
            className={clsx(
              'ml-auto shrink-0 p-1 rounded-[6px] text-[12px] font-bold',
              AttendancePolicyV2HistoryEventBadgeColorMap[kind],
            )}
          >
            {outcomeLabel}
          </Badge>
        </div>
      </div>
    </li>
  );
};
